import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogCustomizadoComponent } from 'src/app/components/genericos/dialog-customizado/dialog-customizado.component';
import { JwtService } from 'src/app/jwt.service';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';
import { Banner } from 'src/app/persistences/banner';
import { BannerService } from 'src/app/services/banner.service';

@Component({
  standalone: false,
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {
  formBannerGravar: FormGroup;
  formBannerEditar: FormGroup;
  private bannerView = new Banner;
  rowHeigthAdicao: number;
  rowHeigthEdicao: number;
  banners: Banner[];
  @Input()
  itemConsultaCdFilial: number;
  @Input()
  itemConsultaCdAcesso: string;
  quantidadeItemGravacao: number;
  quantidadeItemEdicao: number;
  widthDialog: string;
  isLayoutMobile: boolean;
  bannerEditado: Banner;
  nomeArquivoSelecionado = '';
  arquivoSelecionado!: File;
  limparCampoSalvar = false;
  @ViewChild('fileInput') fileInput!: ElementRef;

  constructor(
    private snackBarManager: SnackbarManager,
    private bannerSevice: BannerService,    
    private dialog: MatDialog,
    private jwtService: JwtService,
    private datePipe: DatePipe
  ){ 
  }

  data: Date;

  ngOnInit(): void {  
    this.onResize();
    this.formBannerGravar = new FormGroup({
      cdFilial: new FormControl('',Validators.required),
      dataInicio: new FormControl('', [Validators.required, this.dateValidator]),
      dataFim: new FormControl('', [Validators.required, this.dateValidator]),
      cdAcesso:  new FormControl(''),
      ordem:  new FormControl('',[Validators.required, Validators.pattern("^[0-9]*$")]),
      img: new FormControl(null, Validators.required),
      flTelaLogin: new FormControl(false)
    });

    this.configurarTelaLoginListener(this.formBannerGravar);

    this.carregarBanners();
    this.widthDialog = '400px'
  }

  async salvar() {
    const formValue = this.formBannerGravar.getRawValue();
    this.bannerView.cdFilial = formValue.flTelaLogin 
      ? null 
      : formValue.cdFilial;

    this.bannerView.cdAcesso = formValue.flTelaLogin 
      ? null 
      : formValue.cdAcesso;
      
    const dataInicio = new Date(this.formBannerGravar.get('dataInicio').value);
    const dataFim = new Date(this.formBannerGravar.get('dataFim').value);

    if (formValue.flTelaLogin) {
      formValue.cdFilial = null;
      formValue.cdAcesso = null;
    }

    if (!this.isDateRangeValid(dataInicio, dataFim)) {
      this.snackBarManager.openSnackBar(
        "A data de início deve ser menor ou igual à data de fim",
        "Ok",
        3000
      );
      return;
    }

    if (this.formBannerGravar.invalid) {
      this.formBannerGravar.markAllAsTouched();
      this.snackBarManager.openSnackBar("Formulário invalido", "Ok", 3000);
      return;
    }

    const base64Limpo = this.formBannerGravar.get('img')?.value;
    const nomeImagem = this.nomeArquivoSelecionado;

    this.bannerView.dataInicio = this.datePipe.transform(dataInicio, 'dd/MM/yyyy');
    this.bannerView.dataFim = this.datePipe.transform(dataFim, 'dd/MM/yyyy');
    this.bannerView.ordem = this.formBannerGravar.get('ordem').value;
    this.bannerView.img = base64Limpo;
    this.bannerView.nomeImg = nomeImagem;
    this.bannerView.flTelaLogin = this.formBannerGravar.get('flTelaLogin').value;
    
    this.bannerSevice.gravarBanner(this.bannerView).subscribe(() => {
      this.snackBarManager.openSnackBar("Banner salvo com sucesso", "Ok", 3000);
      this.ngOnInit();
      this.formBannerGravar.reset();
      this.nomeArquivoSelecionado = '';
      this.fileInput.nativeElement.value = '';
      this.bannerView = new Banner();
      this.limparCampoSalvar = true;
    }, error => {
      this.snackBarManager.openSnackBar(
        "Não foi possivel salvar banner: " + error.error,
        "Ok",
        3000
      );
    });
  }
  
  async editar(banner: any) {
    this.bannerEditado = new Banner();

    const formValue = banner.form.getRawValue();

    const dataInicio = new Date(formValue.dataInicio);
    const dataFim = new Date(formValue.dataFim);

    if (!this.isDateRangeValid(dataInicio, dataFim)) {
      this.snackBarManager.openSnackBar(
        "A data de início deve ser menor ou igual à data de fim",
        "Ok",
        3000
      );
      return;
    }

    if (banner.form.invalid) {
      banner.form.markAllAsTouched();
      this.snackBarManager.openSnackBar("Formulário inválido", "Ok", 3000);
      return;
    }

    const base64Limpo = banner.form.get('img').value;
    const nomeImagem = banner.form.get('nomeImg')?.value || banner.nomeImg;

    this.bannerEditado.idGeral = formValue.idGeral;
    this.bannerEditado.dataInicio = this.datePipe.transform(dataInicio, 'dd/MM/yyyy');
    this.bannerEditado.dataFim = this.datePipe.transform(dataFim, 'dd/MM/yyyy');
    this.bannerEditado.ordem = formValue.ordem;
    this.bannerEditado.nomeImg = nomeImagem;
    this.bannerEditado.img = base64Limpo;
    this.bannerEditado.flTelaLogin = formValue.flTelaLogin;
    this.bannerEditado.cdAcesso = formValue.flTelaLogin ? null : formValue.cdAcesso;
    this.bannerEditado.cdFilial = formValue.flTelaLogin ? null : formValue.cdFilial;

    this.bannerSevice.alterarBanner(this.bannerEditado).subscribe(() => {
      this.snackBarManager.openSnackBar("Banner editado com sucesso!", "Ok", 3000);
      this.ngOnInit();
      this.formBannerGravar.reset();
      this.nomeArquivoSelecionado = '';
      this.fileInput.nativeElement.value = '';
    }, (error) => {
      this.snackBarManager.openSnackBar(
        "Não foi possível editar banner: " + error.error,
        "Ok",
        3000
      );
    });
  }

  async excluir(banner: Banner){  
    const mensagem = 'Deseja excluir este banner?';
    const confirmacao = 'Sim';
    const negacao = 'Não';
    
    const dialogRef = this.dialog.open(DialogCustomizadoComponent, {
      width: this.widthDialog,
      height: '100px',
      panelClass: 'custom-dialog',
      data:{labelMensagem: mensagem, labelConfirmacao: confirmacao, labelNegacao: negacao}
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.bannerSevice.deletarBanner(banner.idGeral).subscribe(() => {            
            this.ngOnInit();
            this.snackBarManager.openSnackBar("banner excluido com sucesso!", "Ok", 3000);
          }, (error) =>{
            this.snackBarManager.openSnackBar("Não foi possível excluir banner: " + error.error, "Ok", 3000);
            console.log(error)
          })
        }
      },
      (error) => {
        this.jwtService.validarAcessToken(error);
      }
    );
  }

  getStringToDate(date:string){
    
    const [dia, mes, ano] = date.split('/');
      return new Date(parseInt(ano),parseInt(mes)-1,parseInt(dia))
  }

  getDateToString(date){
    if(date instanceof Date){
      return date.toLocaleDateString();
    } else if(date === undefined) {
      return;
    }else {
      return date._d.toLocaleDateString();
    }
  }

  receberItemConsultaFilial(itemConsulta) {
    this.itemConsultaCdFilial = itemConsulta;
    this.formBannerGravar.get('cdFilial').setValue(itemConsulta);
  }

  receberItemConsultaAcesso(itemConsulta: string) {
    this.itemConsultaCdAcesso = itemConsulta;
    this.formBannerGravar.get('cdAcesso').setValue(itemConsulta);
  }

  receberItemConsultaFilialEditar(itemConsulta, banner) {
    this.itemConsultaCdFilial = itemConsulta;
    banner.form.get('cdFilial').setValue(itemConsulta);
  }

  receberItemConsultaAcessoEditar(itemConsulta: string, banner) {
    this.itemConsultaCdAcesso = itemConsulta;
    banner.form.get('cdAcesso').setValue(itemConsulta);
  }

  private isDateRangeValid(startDate: Date, endDate: Date): boolean {
    if (startDate && endDate && startDate <= endDate) {
      return true;
    }
    return false;
  }

  private dateValidator(control: FormControl): { [key: string]: boolean } | null {
    if (control.value && !isNaN(new Date(control.value).getTime())) {
      return null;
    }
    return { 'invalidDate': true };
  }

  @HostListener('window:resize')
  onResize(){    
    switch(true){
      case(window.innerWidth < 800):{
        this.isLayoutMobile = true;
        this.rowHeigthEdicao = 635;
        this.rowHeigthAdicao = 600;
        break;
      }
      case(window.innerWidth < 880):{
        this.rowHeigthEdicao = 635;
        this.rowHeigthAdicao = 600;
        this.isLayoutMobile = false;
        break;
      }
      case(window.innerWidth > 880 && window.innerWidth < 1060):{
        this.rowHeigthAdicao = 250;
        this.rowHeigthEdicao = 250;
        break;
      }
      case(window.innerWidth > 1061 && window.innerWidth < 1911):{
        this.rowHeigthAdicao = 250;
        this.rowHeigthEdicao = 200;
        break;
      }
      default:{
        this.rowHeigthAdicao = 200;
        this.rowHeigthEdicao = 140;
      }
    }
  }

  async onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    const isLogin = this.formBannerGravar.get('flTelaLogin')?.value;

    const valido = await this.validarImagem(file, isLogin);

    if (!valido) {

      this.formBannerGravar.get('img')?.setValue(null);
      this.nomeArquivoSelecionado = '';
      event.target.value = '';

      return;
    }

    const base64Completo = await this.converterParaBase64(file);
    const base64Limpo = (base64Completo as string).split(',')[1];

    this.nomeArquivoSelecionado = file.name;

    this.formBannerGravar.get('img')?.setValue(base64Limpo);
    this.formBannerGravar.get('nomeImg')?.setValue(file.name);

    this.formBannerGravar.get('img')?.markAsTouched();
    this.formBannerGravar.get('img')?.updateValueAndValidity();
  }

  async onFileSelectedEditar(event: any, banner: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    const isLogin = banner.form.get('flTelaLogin')?.value;

    const valido = await this.validarImagem(file, isLogin);

    if (!valido) {

      banner.form.get('img')?.setValue(null);
      banner.form.get('nomeImg')?.setValue(null);
      banner.nomeImg = '';
      event.target.value = '';

      return;
    }

    const base64Completo = await this.converterParaBase64(file);
    const base64Limpo = (base64Completo as string).split(',')[1];

    banner.form.get('img').setValue(base64Limpo);
    banner.form.get('nomeImg')?.setValue(file.name);
    banner.nomeImg = file.name;
    banner.imgSrc = base64Completo;

    banner.form.get('img')?.markAsTouched();
    banner.form.get('img')?.updateValueAndValidity();
  }

  private converterParaBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }

  private base64ParaBlob(base64: string): Blob {

    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    return new Blob([byteArray], { type: 'image/*' });
  }

  configurarTelaLoginListener(form: FormGroup, banner?: any) { 
    const aplicarRegra = (value: boolean) => { 
      if (value) { 
        if (banner) {
          banner.cdFilial = null;
          banner.cdAcesso = null;
          banner.limparCampo = true;
        }

        form.patchValue({
          cdFilial: null,
          cdAcesso: null
        });

        let imgValue = form.get('img')?.value;
        imgValue = imgValue ? imgValue : banner?.img;

        if (imgValue) {
          let fileParaValidar: File | Blob;

          if (imgValue instanceof File) {
            fileParaValidar = imgValue;
          } else {
            fileParaValidar = this.base64ParaBlob(imgValue);
          }

          this.validarImagem(fileParaValidar as File, value).then(valido => {

            if (!valido) {

              form.get('img')?.setValue(null);
              form.get('nomeImg')?.setValue(null);

              form.get('img')?.setValidators([Validators.required]);
              form.get('img')?.markAsTouched();
              form.get('img')?.updateValueAndValidity();

              this.nomeArquivoSelecionado = '';

              if (this.fileInput) {
                this.fileInput.nativeElement.value = '';
              }
            }

          });

        }

        if (banner) banner.limparCampo = false;
        this.limparCampoSalvar = false;
        form.get('limparCampo')?.setValue(false);

        setTimeout(() => {
          this.limparCampoSalvar = true;
          form.get('limparCampo')?.setValue(true);
          if (banner) banner.limparCampo = true;
        });

        form.get('cdFilial')?.clearValidators(); 
        form.get('cdAcesso')?.clearValidators(); 
        form.get('cdFilial')?.setValue(null); 
        form.get('cdAcesso')?.setValue(null); 
        form.get('cdFilial')?.disable(); 
        form.get('cdAcesso')?.disable(); 
      } else {
        form.get('cdFilial')?.setValidators(Validators.required);
        form.get('cdFilial')?.enable();
        form.get('cdAcesso')?.enable();

        let imgValue = form.get('img')?.value;
        imgValue = imgValue ? imgValue : banner?.img;

        if (imgValue) {
          const fileParaValidar = imgValue instanceof File ? imgValue : this.base64ParaBlob(imgValue);
          this.validarImagem(fileParaValidar as File, false).then(valido => {
            if (!valido) {
              form.get('img')?.setValue(null);
              form.get('nomeImg')?.setValue(null);
              if (banner) banner.nomeImg = '';
              form.get('img')?.setValidators([Validators.required]);
              form.get('img')?.markAsTouched();
              form.get('img')?.updateValueAndValidity();
              if (!banner) {
                this.nomeArquivoSelecionado = '';
                if (this.fileInput) this.fileInput.nativeElement.value = '';
              }
            }
          });
        }
      }

      form.get('cdFilial')?.updateValueAndValidity(); 
      form.get('cdAcesso')?.updateValueAndValidity(); 
      
    }; 
    form.get('flTelaLogin')?.valueChanges.subscribe(aplicarRegra); 
    this.limparCampoSalvar = false;
    form.get('limparCampo')?.setValue(false);

    aplicarRegra(form.get('flTelaLogin')?.value); 
  }

  private carregarBanners() {
    this.bannerSevice.getAll().subscribe(response => {
      this.banners = response.map(banner => {
        const dataInicioDate = this.getStringToDate(banner.dataInicio);
        const dataFimDate = this.getStringToDate(banner.dataFim);
        banner.limparCampo = false;

        const form = new FormGroup({
          idGeral: new FormControl(banner.idGeral, Validators.required), 
          cdFilial: new FormControl(banner.cdFilial, Validators.required),
          dataInicio: new FormControl(dataInicioDate, [Validators.required, this.dateValidator]),
          dataFim: new FormControl(dataFimDate, [Validators.required, this.dateValidator]),
          cdAcesso: new FormControl(banner.cdAcesso),
          ordem: new FormControl(banner.ordem, [Validators.required, Validators.pattern('^[0-9]*$')]),
          img: new FormControl(banner.img, Validators.required),
          nomeImg: new FormControl(banner.nomeImg, Validators.required),
          flTelaLogin: new FormControl(banner.flTelaLogin),
        });

        this.configurarTelaLoginListener(form, banner);

        return { ...banner, form};
      });
      
    }, error => {
      this.snackBarManager.openSnackBar(
        "Não foi possivel carregar banners: " + error.error,
        "Ok",
        3000
      );
    });
  }

  private validarImagem(file: File, isLogin: boolean): Promise<boolean> {
    return new Promise((resolve) => {

      const image = new Image();
      const objectUrl = URL.createObjectURL(file);

      image.onload = () => {

        const largura = image.width;
        const altura = image.height;

        let larguraMin: number;
        let alturaMin: number;
        let larguraMax: number;
        let alturaMax: number;

        if (isLogin) {
          larguraMin = 800;
          alturaMin = 900;
          larguraMax = 1080;
          alturaMax = 1200;
        } else {
          larguraMin = 1280;
          alturaMin = 400;
          larguraMax = 1920;
          alturaMax = 600;
        }

        if (
          largura < larguraMin ||
          altura < alturaMin ||
          largura > larguraMax ||
          altura > alturaMax
        ) {
          this.snackBarManager.openSnackBar(
            `Imagem inválida. Permitido: Min ${larguraMin}x${alturaMin} e Máx ${larguraMax}x${alturaMax}`,
            "Ok",
            5000
          );

          URL.revokeObjectURL(objectUrl);
          resolve(false);
          return;
        }

        URL.revokeObjectURL(objectUrl);
        resolve(true);
      };

      image.src = objectUrl;
    });
  }
}

